export default __webpack_public_path__ + "static/media/logo-hh2.a24cdfe2.png";